<template>
    <div class="timeline-add">
        <h5>Your Progress</h5>
        <p>Ready, Set, Go!</p>
        <div class="timeline-area mt-4">
            <div v-for="(timeline,index) in timelineIteams" :key="index" class="timeline-item" :class="[timeline.timelinesClass,timeline.isFilled ? 'filled' : '']">
                <span>{{ timeline.heading }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CampaignTimeline',
    props: {
        timelineIteams:Array,
    }
}
</script>
